import {
  PLANTING,
  IN_SEASON,
  HARVEST,
  BASE_LAYERS,
} from '../constants/mapLayerIds';
import { LOCALE_GROUPS } from '../constants/units';

/*
 * TCC unit-qty (unit conversion library) configs
 */
type LayerUnit = {
  key?: string;
  localeGroup?: string;
  unitType?: string;
  processSpecial?: string;
  cropNominalWeight?: number | null;
  [key: string]: unknown;
};

const equipmentSpeed: LayerUnit = {
  key: 'kilometer/hour',
  localeGroup: LOCALE_GROUPS.EQUIPMENT_SPEED,
};

const elevation: LayerUnit = {
  key: 'meter',
  localeGroup: LOCALE_GROUPS.ELEVATION,
  unitType: 'unitPlural',
};

const layerUnits: Record<string, LayerUnit> = {
  [`${IN_SEASON.APPLICATIONS}${LOCALE_GROUPS.APPLICATION_DRY}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.APPLICATION_DRY,
  },
  [`${IN_SEASON.APPLICATIONS}${LOCALE_GROUPS.APPLICATION_LIQUID}`]: {
    key: 'liter/hectare',
    localeGroup: LOCALE_GROUPS.APPLICATION_LIQUID,
  },
  [PLANTING.POPULATION]: {
    key: 'seed/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_SHORT,
  },
  [`${PLANTING.POPULATION}${LOCALE_GROUPS.POPULATION_WEIGHT}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_WEIGHT,
  },
  [PLANTING.TARGET_POPULATION]: {
    key: 'seed/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_SHORT,
  },
  [`${PLANTING.TARGET_POPULATION}${LOCALE_GROUPS.POPULATION_WEIGHT}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_WEIGHT,
  },
  [PLANTING.DATE]: {
    processSpecial: 'date',
  },
  [HARVEST.YIELD]: {
    key: 'tonne/hectare',
    localeGroup: LOCALE_GROUPS.YIELD,
  },
  [HARVEST.DATE]: {
    processSpecial: 'date',
  },
  [HARVEST.MOISTURE]: {
    key: 'percent',
    localeGroup: LOCALE_GROUPS.MOISTURE,
  },
  [PLANTING.PLANTER_SPEED]: equipmentSpeed,
  [PLANTING.ORGANIC_MATTER]: {
    key: 'percent',
  },
  [PLANTING.UNIFORM_FURROW]: {
    key: 'percent',
  },
  [PLANTING.DOWN_FORCE]: {
    key: 'kilogram',
    localeGroup: LOCALE_GROUPS.WEIGHT,
  },
  [PLANTING.APPLIED_DOWN_FORCE]: {
    key: 'kilogram',
    localeGroup: LOCALE_GROUPS.WEIGHT,
  },
  [PLANTING.FURROW_MOISTURE]: {
    key: 'percent',
    localeGroup: LOCALE_GROUPS.MOISTURE,
  },
  [PLANTING.CLEAN_FURROW]: {
    key: 'percent',
  },
  [PLANTING.SOIL_TEMPERATURE]: {
    key: 'celsius',
  },
  [HARVEST.COMBINE_SPEED]: equipmentSpeed,
  [BASE_LAYERS.PLANTER_ELEVATION]: elevation,
  [BASE_LAYERS.COMBINE_ELEVATION]: elevation,
};

/**
 * Returns the units key and locale group for the given map layer and crop.
 */
export function getLayerUnits(mapLayer: string, localeGroup = ''): LayerUnit | undefined {
  return layerUnits[`${mapLayer}${localeGroup}`] || undefined;
}
